/**
 * @description 告警走势图 alarmTrend
 * @author xiehan
 * @date 2018/11/21
 */

import Logic from '../logic-base'

const alarmTrendBiz = new Logic()

alarmTrendBiz.get = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.alarmTrend.get,
    data: data
  })
}

alarmTrendBiz.getRankCount = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.alarmTrend.getRankCount,
    data: data
  })
}

alarmTrendBiz.geZabixAlarm = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.alarmTrend.geZabixAlarm,
    data: data
  })
}

alarmTrendBiz.findGroups = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.alarmTrend.findGroups,
    data: data
  })
}

export default alarmTrendBiz
